import React from 'react';
import Loader from 'jsx/components/loader';

export default function DefaultPage() {
  return (
    <div className="sitecontainer-body page--loading">
      <div className="page-loader">
        <Loader />
      </div>
    </div>
  );
};




// WEBPACK FOOTER //
// ./app/assets/jsx/pages/default.jsx